import React from "react";
import styled from "styled-components";
import { CTA } from "../../../components/CTA";
import { RichText } from "../../../components/RichText";
const PromoContent = ({ supertitle, title, subtitle, description, links }) => {
    const richText = description;
    let primaryCTA;
    let tertiaryCTA;
    if (links) {
        if (links[0]) {
            primaryCTA = links[0];
        }
        if (links[1]) {
            tertiaryCTA = links[1];
        }
    }
    return (React.createElement("div", null,
        supertitle && (React.createElement("p", { "data-testid": "mediapromo-supertitle", className: "supertitle" }, supertitle)),
        title && (React.createElement("p", { "data-testid": "mediapromo-title", className: "title" }, title)),
        subtitle && (React.createElement("p", { "data-testid": "mediapromo-subtitle", className: "subtitle" }, subtitle)),
        description && (React.createElement("div", { "data-testid": "mediapromo-description", className: "description" },
            React.createElement(RichText, { ...richText }))),
        links && (React.createElement("div", { "data-testid": "mediapromo-links", className: "links" },
            !!primaryCTA && (React.createElement(CTA, { variant: "primary", className: "primary-link", "data-testid": "header-primary-cta", ...primaryCTA, tabIndex: 0 })),
            !!tertiaryCTA && React.createElement(CTA, { variant: "tertiary", "data-testid": "header-tertiary-cta", ...tertiaryCTA })))));
};
export const MediaPromoContent = styled(PromoContent) ``;
//# sourceMappingURL=MediaPromoContent.js.map